import { ReactElement } from 'react'
import { Box } from '@mui/material'
import Results2HeaderRelationLink from './Results2HeaderRelationLink'

export type Results2RelationLink = {
  label: string
  tooltip: string
  onClick: () => void
}

export type Results2RelationLinksRowProps = {
  links: Results2RelationLink[]
}

const Results2RelationLinksRow = ({
  links,
}: Results2RelationLinksRowProps): ReactElement | null => {
  if (links.length === 0) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
        minWidth: 0,
      }}
    >
      {links.map(link => (
        <Results2HeaderRelationLink
          key={link.label}
          label={link.label}
          tooltip={link.tooltip}
          onClick={link.onClick}
        />
      ))}
    </Box>
  )
}

export default Results2RelationLinksRow
